<svg xmlns="http://www.w3.org/2000/svg" width="25" height="27" viewBox="0 0 25 27">
  <defs>
    <style>
      .cls-1 {
        fill: #fff;
        fill-rule: evenodd;
      }
    </style>
  </defs>
  <g id="medal1" data-name="medal">
    <path
      class="cls-1"
      d="M67.995,52.026a5.491,5.491,0,1,0,5.5,5.492A5.494,5.494,0,0,0,67.995,52.026Zm2.3,8.767-2.3-1.209-2.3,1.209,0.44-2.562-1.863-1.814,2.576-.374,1.151-2.332,1.151,2.332,2.576,0.374-1.864,1.814ZM71.2,50.9L63.473,40H57l7.731,10.9H71.2ZM78.994,40H72.517L68.57,45.569l3.237,4.565Z"
      transform="translate(-56 -38)"
    />
  </g>
</svg>
